<template>
  <div class="language-dropdown">
    <button
      class="dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :aria-label="$t('header.language')"
      :title="$t('header.language')"
    >
      <img src="../../../assets/img/icons/globe.svg" :alt="$t('header.language')" />
    </button>
    <div
      class="dropdown-menu rounded-1 bg-white border-0 start-auto end-0"
      data-popper-placement="bottom-start"
    >
      <ul class="list-style dropdown-body">
        <li>
          <button
            class="flag-item border-0 bg-transparent text-start d-flex align-items-center p-0"
            @click="changeLanguage('en')"
          >
            <img src="../../../assets/img/flags/uk.webp" :alt="$t('header.english')" />
            <span class="text-title fs-14 d-block ms-3" :class="{ 'fw-bold': currentLocale === 'en' }">
              {{ $t("header.english") }}
            </span>
          </button>
        </li>
        <li>
          <button
            class="flag-item border-0 bg-transparent text-start d-flex align-items-center p-0"
            @click="changeLanguage('km')"
          >
            <div class="khmer-flag-placeholder d-flex align-items-center justify-content-center bg-light rounded" style="width: 40px; height: 26px;">
              🇰🇭
            </div>
            <span class="text-title fs-14 d-block ms-3" :class="{ 'fw-bold': currentLocale === 'km' }">
              {{ $t("header.khmer") }}
            </span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "LanguageDropdown",
  setup() {
    const { locale } = useI18n();

    const currentLocale = computed(() => locale.value);

    const changeLanguage = (lang: string) => {
      locale.value = lang;
      localStorage.setItem("lang", lang);
    };

    return {
      currentLocale,
      changeLanguage,
    };
  },
});
</script>

<style lang="scss" scoped>
.language-dropdown {
  .dropdown-menu {
    width: 225px;
    font-size: 14px;
    box-shadow: 0px 4px 34px rgba(101, 96, 240, 0.1);
    margin-top: 19px !important;
    margin-right: -10px !important;
    .dropdown-body {
      padding: 15px 30px;
      li {
        position: relative;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 15px;
        padding-bottom: 15px;
        &:last-child {
          padding-bottom: 0;
          margin-bottom: 0;
          border-bottom: none;
        }
        button {
          img {
            max-width: 40px;
          }
        }
      }
    }
  }
}
</style>
